import React, { useState } from 'react';
import { SdfBox, SdfQuickStat, SdfRadioButton, SdfSpotIllustration } from '@synerg/react-components';
function StepFour({ state = {}, dispatch, control, useCases, selectedUseCaseBtnIndex, setSelectedUseCaseBtnIndex }) {
	const dtrum = global.window.dtrum;
	const { companySize = 'mid', appStore } = state;
	const [ searchBy ] = useState('');

	const thisUseCases = useCases.filter(({ locale, hideIndicator, sizes }) => sizes.includes(companySize || 'mid') && !hideIndicator && locale === appStore);

	const lc = text => (text || '').toLowerCase();

	let displayUseCases = searchBy ? (thisUseCases.filter( ({ title }) => lc(title).indexOf(lc(searchBy)) !== -1 )) : thisUseCases;
	displayUseCases.sort((a, b) => {
		const isOtherTransformation = t => t.indexOf('other') === 0 ? 'zzzzzzzzz' : t;
		const at = isOtherTransformation(lc(a.title));
		const bt = isOtherTransformation(lc(b.title));
		if (at < bt) { return -1; }
		if (at === bt) { return 0; }
		return 1;
	});

	function getIllustrationByCategory(category) {
		switch (category) {
			case 'benefits':
				return 'health-crest';
			case 'benefits administration':
				return 'heart-hands';
			case 'compliance':
				return 'clipboard';
			case 'empIncomeVerification':
				return 'person';
			case 'learning management':
				return 'certificate';
			case 'other':
				return 'shield';
			case 'productivity & collaboration':
				return 'high-five';
			case 'performance':
				return 'trophy';
			case 'payroll':
				return 'money-hand';
			case 'retention':
				return 'connections';
			case 'recruiting':
				return 'people-3';
			case 'time':
				return 'time-sheets';
			default:
				return 'warning';
		}
	}

	return (
		<>
			<div className="mt-8">
				<span className="text-heading-05 font-bold mb-4	">Use case selection</span>
				<p className="text-body-02 mb-6">Select a use case that best describes the type of data you need for your integration.</p>
				<span className="text-heading-05 font-bold">Which data set best fits your integration use case?</span>

				<div className="mt-8 overflow-y-scroll pr-4" style={{height: "24rem"}}>
					<section data-cvs-id="appStore-US" className="items-center justify-center h-full grid grid-cols-3 gap-4">
						{displayUseCases && displayUseCases.map(({ _id: id, title, description, category}, index) => (

							<SdfBox
								className="justify-center h-full min-h-24 max-h-30"
								variant="bordered"
								spacing="default"
								key={index}>
								<SdfQuickStat
									size="md"
									// labelPosition={'bottom'}
									onClick={() => {
										const actionId = dtrum?.enterAction('usecase_selection '+title, 'button');
    									console.log('Dtrum action id on usecase selection - ', actionId);
										dispatch({ type: 'UPDATE', payload: { useCaseID: id, useCaseName: title } });
										setSelectedUseCaseBtnIndex(index);
										dtrum?.leaveAction(actionId);
									}}
								>
									<div className='flex text-sm'>
										<SdfRadioButton value="US" checked={index === selectedUseCaseBtnIndex}/>
									</div>
									<div className="flex flex-col items-center overflow-hidden px-4">
										<SdfSpotIllustration
											illustrationName={getIllustrationByCategory(category)}
											size="md"
										/>
										<div className="text-heading-05 font-bold text-center capitalize mt-1 mb-2">{title}</div>
										<div className="text-body-01 font-normal wrap text-center ellipsis normal-case mb-4">{description}</div>
									</div>
								</SdfQuickStat>
							</SdfBox>
						))}
					</section>
				</div>
			</div>
		</>
	)
}

export default StepFour;
